import { companyHistoricalApi } from "@/main/api";
import CompanyHistoricalGrid, { IDataGridCompanyTypeHistorical } from "./companyHistoricalGrid";
import { CompanyHistoricalRequest } from "@/main/models/request/companyHistoricalRequest";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { isEmpty, isNil } from "lodash";
import { useEffect, useState } from "react";
import { CompanyHistoricalResponse } from "@/main/models/response/companyHistoricalResponse";

export const INITIAL_GRID_STATE: IDataGridCompanyTypeHistorical = {
	isLoading: false,
	totalItems: 0,
	data: [],
};

const INITIAL_FORM_FILTERS: CompanyHistoricalRequest = {
	guidCompany: "",
	pageIndex: PaginationEnum.PageIndexIntial,
	pageSize: PaginationEnum.PageSize30,
};

interface Props {
	guidCompany?: string | null;
}

export default function CompanyHistorical({ guidCompany }: Props) {
	const [formFilters, setFormFilters] = useState<CompanyHistoricalRequest | null>(null);

	const [gridData, setGridData] = useState<IDataGridCompanyTypeHistorical>(INITIAL_GRID_STATE);

	useEffect(() => {
		initialLoad();
	}, [guidCompany]);

	function initialLoad() {
		if (isEmpty(guidCompany) || isNil(guidCompany)) {
			return;
		}

		const requestGrid: CompanyHistoricalRequest = {
			...INITIAL_FORM_FILTERS,
			guidCompany: guidCompany,
		};

		setFormFilters(requestGrid);

		setGridData((crr) => ({ ...crr, isLoading: true }));

		companyHistoricalApi
			.getHistorical(requestGrid)
			.then((response) => {
				let resultData: CompanyHistoricalResponse[] = [];
				let resultTotalItems: number = 0;
				if (response.data) {
					resultData = response.data.results;
					resultTotalItems = response.data.totalNumberOfRecords;
				}

				const newData = resultData.filter(
					(item: any) => !gridData.data.some((existing: any) => existing.guid === item.guid),
				);
				const updatedData = [...gridData.data, ...newData];
				setGridData({
					isLoading: false,
					totalItems: resultTotalItems,
					data: updatedData,
				});
			})
			.finally(() => setGridData((crr) => ({ ...crr, isLoading: false })));
	}

	return <CompanyHistoricalGrid formFilters={formFilters} gridData={gridData} setGridData={setGridData} />;
}
